import {
  ConfirmModalComponent,
  EmptyPageComponent,
  StatusChipComponent,
  SynDialogConfig,
} from '$synapse/core';
import { Exam, Candidate, compareExams } from '$synapse/models';
import { ExamService } from '$synapse/services';
import { Component, Input, OnInit, inject } from '@angular/core';
import { Router } from '@angular/router';
import { KeycloakService } from 'keycloak-angular';
import { mergeMap } from 'rxjs';
import { ExamCreationModalComponent } from '../exam-creation-modal/exam-creation-modal.component';
import { ManagerDto } from '$synapse/dtos';
import { MatDialog } from '@angular/material/dialog';
import { SHARED_IMPORTS } from '../../../core/shared-imports';
import { CertifiedAssessmentIconComponent } from '../../../core/components/certified-assessment-icon/certified-assessment-icon.component';

@Component({
  selector: 'syn-candidate-exams-list-widget',
  templateUrl: './candidate-exams-list-widget.component.html',
  styleUrls: ['./candidate-exams-list-widget.component.scss'],
  imports: [
    SHARED_IMPORTS,
    StatusChipComponent,
    EmptyPageComponent,
    CertifiedAssessmentIconComponent,
  ],
})
export class CandidateExamListWidgetComponent implements OnInit {
  private readonly _modalDialog = inject(MatDialog);
  private readonly _keycloakService = inject(KeycloakService);
  private readonly _router = inject(Router);
  private readonly _examService = inject(ExamService);

  @Input() candidate: Candidate;

  currentPage: number[] = [];
  readonly pageSize = 10;
  pageIndex = 0;
  managerId: string;

  constructor() {
    for (let i = 0; i < this.pageSize; i++) {
      this.currentPage.push(i);
    }
  }

  ngOnInit(): void {
    this._keycloakService
      .getKeycloakInstance()
      .loadUserInfo()
      .then((user) => (this.managerId = (user as ManagerDto).sub));
  }

  createAssessment() {
    const dialogRef = this._modalDialog.open(
      ExamCreationModalComponent,
      new SynDialogConfig('modal-assessment-component')
    );
    const instance = dialogRef.componentInstance;
    instance.candidateId = this.candidate.id;
    instance.addExam
      .pipe(mergeMap(($event) => this._examService.addOne($event)))
      .subscribe((assessment) => {
        this.candidate.exams.push(assessment);
        this.candidate.exams.sort(compareExams);
      });
  }

  removeExam(id: string): void {
    const dialogRef = this._modalDialog.open(
      ConfirmModalComponent,
      new SynDialogConfig('modal-popup-component')
    );
    const instance = dialogRef.componentInstance;
    instance.title = "Suppression d'évaluation";
    instance.message = 'Êtes-vous sûr de vouloir supprimer cette évaluation ?';
    instance.action = 'Supprimer';
    instance.confirmationEvent.subscribe(() => {
      this._examService.deleteOne(id).subscribe(() => {
        this.candidate.exams = this.candidate.exams.filter(
          (exam) => exam.uuid !== id
        );
      });
    });
  }

  setCurrentPage(direction: number, candidatLength: number) {
    if (
      candidatLength > (this.pageIndex + 1) * this.pageSize ||
      direction === -1
    ) {
      this.pageIndex = Math.max(this.pageIndex + direction, 0);
      this.currentPage = [];
      for (
        let i = this.pageIndex * this.pageSize;
        i < this.pageIndex * this.pageSize + this.pageSize;
        i++
      ) {
        this.currentPage.push(i);
      }
    }
  }

  navigateToExam(exam: Exam) {
    exam.candidate = this.candidate;
    this._router.navigate([`/exams/${exam.uuid}`], {
      state: { exam: exam },
    });
  }
}
